import React from 'react';

import { faPlus } from '@fortawesome/fontawesome-free-solid';

import { getTheme } from '../../../constants/getTheme';
import TableUsers from '../../helper/tableUsers';
import withSelectedPractices
  from '../../HOCS/withSelectedPractices/withSelectedPractices';
import { TemplateWrapped } from '../../Layout';
import {
  HeaderButton,
  HeaderFilterButton,
} from '../../RemarkTemplate/Body';
import { Presentational as Connections } from '../Connections';
import UserFilters from './UserFilters/UserFilters';
import useUsers from './useUsers';

const Users = ({
  actions = {
    create_user: true,
    delete_user: true,
    update_user: true,
  },
}) => {
  actions = {
    create_user: true,
    delete_user: true,
    update_user: true,
    toggleUser: true,

  };

  const {
    selectedPractices,
    history,
    tableReference,
    dataSource,
    refreshData,
  } = useUsers();
  const theme = getTheme(process.env.REACT_APP_CLIENT_THEME);

  return (
    <TemplateWrapped
      title="Users"
      showTitle={false}
      headerButtons={
        <>
          <HeaderFilterButton
            active={true}
            render={UserFilters}
            componentProps={{
              setFilters: refreshData,
              theme,
            }}
            theme={theme}
          />
          <HeaderButton
            icon={faPlus}
            message="Add a new User"
            onClick={() => {
              history({ pathname: "/user-form" });
            }}
          />
        </>
      }
    >
      <div
        className="panel"
        style={{
          backgroundColor: "transparent",
          boxShadow: "none",
        }}
      >
        <div className="panel-body">
          <main className="flex-1 pt-6 pb-8">
            {/* Page Header */}
            <div className="mb-8 flex justify-between items-center">
              <h1 className="text-2xl font-bold text-gray-900 mb-2">Users</h1>
              <div className="flex space-x-2 items-center">
                <div>
                  <HeaderFilterButton
                    active={true}
                    render={UserFilters}
                    componentProps={{
                      setFilters: refreshData,
                      theme,
                    }}
                    theme={theme}
                  />
                </div>
                <div>
                  <HeaderButton
                    icon={faPlus}
                    message="Add a new User"
                    onClick={() => {
                      history({ pathname: "/user-form" });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {selectedPractices.length > 0 ? (
                  <TableUsers
                    tableReference={tableReference}
                    refresh={refreshData}
                    canEdit={actions.update_user}
                    canDelete={actions.delete_user}
                    statusUser={actions.toggleUser}
                    data={dataSource}
                    theme={theme}
                  />
                ) : (
                  <div className="mb-5 pb-5">
                    <Connections title="Please select a connection" />
                  </div>
                )}
              </div>
            </div>
          </main>
        </div>
      </div>
    </TemplateWrapped>
  );
};

export default withSelectedPractices(Users);
